/**
 * Admin Booking Configuration Constants
 * Frontend configuration values and UI dimensions for admin booking module.
 */

/**
 * Daily booking limit constraints
 */
export const DAILY_BOOKING_LIMITS = {
  MIN: 1,
  MAX: 100,
  DEFAULT: 5,
};

/**
 * Minimum active admins required for system functionality
 */
export const MIN_ACTIVE_ADMINS_REQUIRED = 1;

/**
 * UI Table Column Widths (pixels)
 */
export const TABLE_COLUMN_WIDTHS = {
  ADMIN_NAME: 220,
  ACTIVE: 160,
  HIGH_PRIORITY: 160,
  MAX_DAILY_LIMIT: 200,
};

/**
 * UI Component Dimensions and Styling
 */
export const UI_DIMENSIONS = {
  AVATAR_SIZE: 36,
  AVATAR_FONT_SIZE: 14,
  SWITCH_WIDTH: 44,
  SWITCH_HEIGHT: 22,
  TAG_MIN_WIDTH: 70,
  TAG_HEIGHT: 20,
  INPUT_NUMBER_WIDTH: 100,
  INPUT_NUMBER_HEIGHT: 32,
};

/**
 * Validation Error Messages
 */
export const VALIDATION_ERRORS = {
  NO_ACTIVE_ADMINS: 'At least one admin must remain active to prevent system deadlock.',
  INACTIVE_WITH_PRIORITY: 'Inactive admins cannot have high priority enabled.',
  INVALID_DAILY_LIMIT: `Daily limit must be between ${DAILY_BOOKING_LIMITS.MIN} and ${DAILY_BOOKING_LIMITS.MAX}.`,
  LOAD_ERROR: 'Failed to load admin configurations. Please try again.',
  SAVE_ERROR: 'Failed to save configurations. Please try again.',
};

/**
 * Success Messages
 */
export const SUCCESS_MESSAGES = {
  CONFIG_SAVED: 'Admin configurations saved successfully',
  CHANGES_DISCARDED: 'Changes discarded',
};

/**
 * Info Messages
 */
export const INFO_MESSAGES = {
  ROUND_ROBIN_DISABLED: 'Not available in Round Robin mode',
  NO_UPDATE_PERMISSION: 'Update permission required',
};

/**
 * Notification Display Durations (seconds)
 */
export const NOTIFICATION_DURATION = {
  SUCCESS: 2.5,
  ERROR: 3,
  WARNING: 3,
  INFO: 2,
};

/**
 * Permission-related constants
 */
export const PERMISSION_CONFIG = {
  MODULE: 'admin_booking_config',
  ACTION: 'update',
};

/**
 * UI Component Size Configuration (backward compatible names)
 * @deprecated Use UI_DIMENSIONS instead
 */
export const AVATAR_CONFIG = {
  SIZE: UI_DIMENSIONS.AVATAR_SIZE,
  FONT_SIZE: UI_DIMENSIONS.AVATAR_FONT_SIZE,
};

/**
 * @deprecated Use UI_DIMENSIONS instead
 */
export const SWITCH_CONFIG = {
  WIDTH: UI_DIMENSIONS.SWITCH_WIDTH,
  HEIGHT: UI_DIMENSIONS.SWITCH_HEIGHT,
};

/**
 * @deprecated Use UI_DIMENSIONS instead
 */
export const TAG_CONFIG = {
  MIN_WIDTH: UI_DIMENSIONS.TAG_MIN_WIDTH,
  HEIGHT: UI_DIMENSIONS.TAG_HEIGHT,
};

/**
 * @deprecated Use DAILY_BOOKING_LIMITS instead
 */
export const ADMIN_BOOKING_LIMITS = DAILY_BOOKING_LIMITS;

export const INPUT_NUMBER_CONFIG = {
  WIDTH: UI_DIMENSIONS.INPUT_NUMBER_WIDTH,
  HEIGHT: UI_DIMENSIONS.INPUT_NUMBER_HEIGHT,
};
